import { AxiosResponse } from "axios";
import ApiResponse from "../models/ApiResponse";
import TestRequestResponse from "../models/test-request/TestRequestResponse";
import Api from "./Api";

class TestRequestLifecycleApi {
  constructor(private api: Api) {}

  public acceptTestRequest(requestId: string): ApiResponse<TestRequestResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/accept`);
  }

  public approveTestRequest(requestId: string) {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/approve`);
  }

  public askForReviewForTestRequest(requestId: string): Promise<AxiosResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/ask-for-review`);
  }

  public cancelTestRequest(requestId: string): Promise<AxiosResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/cancel`);
  }

  public declineTestRequest(requestId: string): Promise<AxiosResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/decline`);
  }

  public deleteTestRequest(requestId: string): Promise<AxiosResponse> {
    return this.api.delete(`/test-request/v2/testrequests/${requestId}`);
  }

  public recallTestRequest(requestId: string): ApiResponse<TestRequestResponse> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/recall`);
  }

  public reopenTestRequest(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/reopen`);
  }

  public sendForApproval(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/ask-for-approval`);
  }

  public submitTestRequest(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/submit`);
  }

  public updateTestRequestToComplete(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/complete`);
  }

  public updateTestRequestToWon(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/change-sub-state`, JSON.stringify("WON"), {
      headers: {
        "content-type": "application/json",
      },
    });
  }

  public updateTestRequestToLost(requestId: string): Promise<AxiosResponse<TestRequestResponse>> {
    return this.api.put(`/test-request/v2/testrequests/${requestId}/change-sub-state`, JSON.stringify("LOST"), {
      headers: {
        "content-type": "application/json",
      },
    });
  }
}

export default TestRequestLifecycleApi;
